export default __webpack_public_path__ + "static/ds-theming-dark-light-f8fd74d124412f3b37516d062432d164.png";